import React from "react";
import "./LinkButton.css";

export default function LinkButton(props) {
  const linkButtonClass = props.classes
    ? props.classes + " link-button"
    : "link-button";

  return (
    <button onClick={props.onClick} className={linkButtonClass}>
      {props.children}
    </button>
  );
}
